import Bottleneck from 'bottleneck';
import {getSafeRequestConfig, isConfigLoaded} from './safeConfig';

// Create limiter with dynamic config that updates when config is loaded
let limiter: Bottleneck;

const createLimiter = () => {
    const {maxConcurrent, minTime} = getSafeRequestConfig();
    return new Bottleneck({
        maxConcurrent,
        minTime
    });
};

// Initialize limiter
limiter = createLimiter();

// Update limiter when config is loaded
const updateLimiterOnConfigLoad = () => {
    if (isConfigLoaded()) {
        // Config is already loaded, update limiter
        const {maxConcurrent, minTime} = getSafeRequestConfig();
        limiter.updateSettings({
            maxConcurrent,
            minTime
        });
    } else {
        // Listen for config loaded event
        const handleConfigLoaded = () => {
            const {maxConcurrent, minTime} = getSafeRequestConfig();
            limiter.updateSettings({
                maxConcurrent,
                minTime
            });
            window.removeEventListener('configLoaded', handleConfigLoaded);
        };
        
        window.addEventListener('configLoaded', handleConfigLoaded);
    }
};

// Update limiter configuration when config loads
updateLimiterOnConfigLoad();

export default limiter;
